<script>
	import LoginPanel from "../panels/LoginPanel.svelte";
</script>


<!-------------------------------- HTML -------------------------------------->

<div class="bg-image">
	<LoginPanel />

	<div class="intro">

		<header class="intro-header">
			<img class="logo" src="/static/buttons/new/logoText.svg" alt="Logo"/>
			<h1>Einführung ins Rollenspiel</h1>
		</header>

		<section class="intro-section" data-help="intro">
			<div class="text">
				<h2>Willkommen</h2>
				<p>Willkommen beim Tutorial zum Ausprobieren von <strong>Pentelion</strong>, einem Rollenspielsystem mit
					Online-Komponente. Wir wollen dir eine kleine Einführung in das Spiel geben. Du brauchst keine
					Vorkenntnisse für dieses Tutorial. Falls Du schon Fantasy-Rollenspiele gemacht hast, egal ob klassische
					Pen&amp;Paper oder am Computer, dann kannst Du die nächsten Seiten schnell durchgehen.</p>
				<p>Scrolle einfach weiter nach unten, um mit der Einführung zu starten.</p>
			</div>
			<div class="screenshot">
				<img src="/static/images/intro/willkommen.png" alt="Willkommen" onerror={(e) => e.currentTarget.closest('.screenshot').classList.add('missing')} />
				<div class="placeholder">Willkommen</div>
			</div>
		</section>

		<section class="intro-section reverse" data-help="whatis">
			<div class="text">
				<h2>Was ist ein Rollenspiel</h2>
				<p>Bei einem Fantasy-Rollenspiel hat sich jemand (wir nennen ihn den <strong>Spielleiter</strong> oder
					<strong>Meister</strong>) eine Geschichte ausgedacht, die mehreren Charakteren in einer erfundenen Welt
					zustößt. Diese <strong>Charaktere</strong> werden von jeweils einem Mitspieler geführt. Entweder sitzen
					sie um einen Tisch, oder einige oder alle sind online, oder sie sind in einem Computerspiel - dann ist
					der Computer der Spielleiter. Die Spieler reagieren auf die Geschichte des Spielleiters oder setzen
					eigene Ideen in der Spielwelt um, die manchmal mit der Geschichte überhaupt nichts zu tun haben müssen.
					Das Ziel ist es, Spaß zu haben und seinen Charakter weiterzubringen - den gespielten und vielleicht auch
					den eigenen. Aber vor allem Spaß.</p>
			</div>
			<div class="screenshot">
				<img src="/static/images/intro/rollenspiel.png" alt="Was ist ein Rollenspiel" onerror={(e) => e.currentTarget.closest('.screenshot').classList.add('missing')} />
				<div class="placeholder">Was ist ein Rollenspiel</div>
			</div>
		</section>

		<section class="intro-section" data-help="character">
			<div class="text">
				<h2>Deine Charaktere</h2>
				<p>Jeder Spieler führt einen Charakter. Fantasy-Rollenspiele spielen in einer Fantasy-Welt, die oft vom
					Herrn der Ringe und ähnlichen Werken inspiriert ist. Die Charaktere sind also oft Menschen, Elben oder
					Zwerge, Krieger, Heiler oder Magier. Ein Regelwerk beschreibt die Interaktionsmöglichkeiten der
					Charaktere mit ihrer Umwelt und wie sie sich im Laufe der Zeit verbessern können.</p>
			</div>
			<div class="screenshot">
				<img src="/static/images/intro/charaktere.png" alt="Deine Charaktere" onerror={(e) => e.currentTarget.closest('.screenshot').classList.add('missing')} />
				<div class="placeholder">Deine Charaktere</div>
			</div>
		</section>

		<section class="intro-section reverse" data-help="master">
			<div class="text">
				<h2>Der Meister</h2>
				<p>Der Spielleiter ist für die Geschichte verantwortlich und führt alle anderen Figuren der Spielwelt.
					Insbesondere muss er überlegen, wie die Handlungen der Spieler die Spielwelt verändern. Das kann
					manchmal ein bisschen aufwändig sein (den Spielern fallen oft die verrücktesten Sachen ein), macht aber
					immer Spaß.</p>
			</div>
			<div class="screenshot">
				<img src="/static/images/intro/meister.png" alt="Der Meister" onerror={(e) => e.currentTarget.closest('.screenshot').classList.add('missing')} />
				<div class="placeholder">Der Meister</div>
			</div>
		</section>

		<section class="intro-section" data-help="rulesintro">
			<div class="text">
				<h2>Regeln</h2>
				<p>Jedes Rollenspiel hat Regeln, damit klar ist, wie man mit der Umwelt interagieren kann. Ohne Regeln
					herrscht Chaos, und das ist nach kürzester Zeit langweilig. Die Regeln von Pentelion sind im Laufe
					vieler Jahre gereift, sie bilden einen guten Kompromiss zwischen <em>"Zu schnell, zu mächtig"</em> und
					<em>"ich kann leider gar nichts machen, da zu schwach"</em>. Der Online-Client von Pentelion wurde seit
					der Pandemie entwickelt, er ermöglicht uns, online oder hybrid zu spielen, ohne dabei die Kontrolle ganz
					an den Computer abzugeben. Pentelion ist immer noch ein Pen-und-Paper-Rollenspiel, nur heutzutage ohne
					Pen und ohne Paper. Der Spielleiter muss dabei manches am Computer vorbereiten, vor allem die
					Battle-Maps und die Gegenspieler der Charaktere.</p>
			</div>
			<div class="screenshot">
				<img src="/static/images/intro/regeln.png" alt="Regeln" onerror={(e) => e.currentTarget.closest('.screenshot').classList.add('missing')} />
				<div class="placeholder">Regeln</div>
			</div>
		</section>

	</div>
</div>


<!-------------------------------- STYLES -------------------------------------->

<style lang="sass">
	@use "../colors" as colors

	.bg-image
		background-image: url("/static/images/background.png")
		height: 100%
		overflow-y: auto

	.intro
		max-width: 1100px
		margin: 0 auto
		padding: 140px 60px 100px 60px

	.intro-header
		text-align: center
		margin-bottom: 60px

		.logo
			width: 300px
			filter: drop-shadow(0px 0px 12px rgba(0, 0, 0, 1))

		h1
			margin-top: 20px
			font-size: 28px

	.intro-section
		display: flex
		flex-flow: row nowrap
		align-items: center
		gap: 50px
		background: linear-gradient(90deg, rgba(37,38,38,0.7) 0%, rgba(37,38,38,0.4) 100%)
		border-radius: 8px
		padding: 30px
		margin-bottom: 40px

		&.reverse
			flex-flow: row-reverse nowrap
			background: linear-gradient(270deg, rgba(37,38,38,0.7) 0%, rgba(37,38,38,0.4) 100%)

	.text
		flex: 1 1 55%
		line-height: 1.5

		h2
			margin-top: 0
			color: colors.$white

	.screenshot
		flex: 1 1 45%
		position: relative
		min-height: 180px
		display: flex
		align-items: center
		justify-content: center

		img
			width: 100%
			border-radius: 6px
			box-shadow: 0 4px 12px rgba(0, 0, 0, 0.6)

		.placeholder
			display: none
			width: 100%
			height: 180px
			align-items: center
			justify-content: center
			border: 2px dashed colors.$grey-50
			border-radius: 6px
			color: colors.$grey-85
			text-align: center
			padding: 10px

		&:global(.missing) img
			display: none

		&:global(.missing) .placeholder
			display: flex

</style>
